<template>
  <card-layout>
    <template v-slot:content>
      <div class="bold my-3 text-large">
        404 - Page not found
      </div>
      <div class="content">
        <div class="text-secondary pb-4">
          The page you’re looking for was not found on this server. The page was changed or removed.
        </div>
        <router-link to="/">
          All you can do now is start over.
        </router-link>
      </div>
    </template>
  </card-layout>
</template>

<script>
/**
 * This component shows a Card containing messages related to 404 errors
 */
import CardLayout from '@/components/CardLayout'
export default {
  name: 'NotFoundCard',
  components: {
    CardLayout
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.content a {
  border-bottom: 1px solid $borderPrimary;
  &,
  &:hover {
    color: $secondary;
    text-decoration: none;
  }
  &:hover {
    border-bottom-color: $secondary;
  }
}
</style>
